import { render, staticRenderFns } from "./GoRendezVousButton.vue?vue&type=template&id=56d3fddc&"
import script from "./GoRendezVousButton.vue?vue&type=script&lang=js&"
export * from "./GoRendezVousButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports